import '../../scss/modules/_team.scss'

import Vue from 'vue'
import vueCustomElement from 'vue-custom-element'
//import 'document-register-element/build/document-register-element' // IE polyfill
Vue.use(vueCustomElement)

import VTeam from './VTeam/VTeam.vue'
Vue.customElement('v-team', VTeam)
